import { render, staticRenderFns } from "./CustomerOverviewPage.vue?vue&type=template&id=03dd6a94&scoped=true&"
import script from "./CustomerOverviewPage.vue?vue&type=script&lang=js&"
export * from "./CustomerOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOverviewPage.vue?vue&type=style&index=0&id=03dd6a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dd6a94",
  null
  
)

export default component.exports